<template>
  <b-modal
    id="modal-add-dvir-record"
    centered
    no-close-on-backdrop
    no-close-on-esc
    :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
    :body-class="'px-3 pt-2 pb-4'"
    :header-class="'align-items-center'"
    @show="onShow"
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title">
        {{ $t("dvir.addDvir") }}
      </h5>
      <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
        Close Modal
      </b-button>
    </template>
    <div class="text-left select_arrow">
      <label class="state">{{ $t("maintenanceShared.unitNo") }}</label>
      <v-select
        class="bg_white w-100 f-12"
        v-model="unitID"
        :options="unitOptions"
        item-value="id"
        item-text="label"
        :reduce="(option) => option.id"
        @search="searchAssets"
        @input="onUnitSelected"
      >
        <template #no-options>
          {{ $t("dvir.searchUnits") }}
        </template>
      </v-select>
      <p v-if="errors && errors.unit" class="field-error">
        {{ errors.unit[0] }}
      </p>
    </div>
    <b-form-group v-if="unitID" :label="$t('dvir.template')" class="text-left mb-0 mt-3">
      <b-form-select class="f-12" v-model="templateID" :options="templateOptions"></b-form-select>
      <p v-if="errors && errors.template" class="field-error">
        {{ errors.template[0] }}
      </p>
    </b-form-group>
    <template #modal-footer>
      <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
        <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary" @click="close">
          {{ $t("dvir.cancel") }}
        </b-button>
        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="next">
          {{ $t("maintenanceShared.next") }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "AddDVIR",
  components: { vSelect },
  data() {
    return {
      unitID: null,
      unitOptions: [],
      templateID: null,
      templates: [],
      errors: {},
    };
  },
  computed: {
    templateOptions() {
      return [
        { value: null, text: this.$t("dvir.selectTemplate") },
        ...this.templates.map((template) => ({ value: template.id, text: template.name })),
      ];
    },
  },
  methods: {
    ...mapActions([
      "getDVIRTemplatesByUnit",
      "getFilteredEquipments",
      "addDVIRInspection",
      "setNotification",
      "setLoader",
    ]),
    onShow() {
      this.unitID = null;
      this.unitOptions = [];
      this.templateID = null;
      this.templates = [];
      this.errors = {};
    },
    async onUnitSelected() {
      // Templates are looked up per unit, so this only runs once one is picked —
      // no fetching the full list up front.
      this.templateID = null;
      this.templates = [];
      const unit = this.unitOptions.find((option) => option.id === this.unitID);
      if (!unit) return;
      try {
        const data = await this.getDVIRTemplatesByUnit(unit.id);
        this.templates = data?.data || [];
      } catch (error) {
        console.error("Error fetching DVIR templates:", error);
      }
    },
    async searchAssets(searchText) {
      if (!searchText) return;
      try {
        const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
        const options = (equipmentRecords || []).map((item) => ({
          id: `${item.id}`,
          label: item.unit_no,
          type: item.type,
        }));
        // Keep the option behind the current pick so its label survives a new search.
        const selected = this.unitOptions.filter((option) => option.id === this.unitID);
        this.unitOptions = [...new Map([...selected, ...options].map((item) => [item.id, item])).values()];
      } catch (error) {
        console.error("Error searching units:", error);
      }
    },
    close() {
      this.$bvModal.hide("modal-add-dvir-record");
    },
    async next() {
      if (!this.unitID) {
        this.errors = { unit: [this.$t("dvir.unitRequired")] };
        return;
      }
      if (!this.templateID) {
        this.errors = { template: [this.$t("dvir.templateRequired")] };
        return;
      }
      const unit = this.unitOptions.find((option) => option.id === this.unitID);
      const template = this.templates.find((item) => item.id === this.templateID);
      try {
        this.setLoader(true);
        // Creates the inspection up front; the response carries the id the rest
        // of the flow fills against.
        const inspection = await this.addDVIRInspection({
          unit_id: Number(this.unitID),
          template: this.templateID,
        });
        this.close();
        this.$emit("next", { unit, template, inspection });
      } catch (error) {
        await this.setNotification({
          msg: this.apiError(error),
          type: "error",
          color: "red",
        });
      } finally {
        this.setLoader(false);
      }
    },
    apiError(error) {
      if (typeof error === "string") return error;
      if (error?.error) return error.error;
      if (error?.detail) return error.detail.error || error.detail;
      const firstField = error && Object.values(error)[0];
      if (Array.isArray(firstField)) return firstField[0];
      return firstField || this.$t("dvir.dvirCreateFailed");
    },
  },
};
</script>
